import React, { useCallback, useEffect, useRef, useState } from 'react'

import NavigationPopup from './NavigationPopup'

function NavigationItem({
  className,
  content,
  setOnClickCallback,
  setBadgeCount,
  width,
  onCloseCallback,
}) {
  const wrapperRef = useRef(null)
  const [showModal, toggleModal] = useState(false)

  const togglePopup = () => toggleModal(!showModal)

  const hideModal = useCallback(() => {
    toggleModal(false)
  }, [])

  useEffect(() => {
    if (!showModal) {
      onCloseCallback()
    }
  }, [showModal, onCloseCallback])

  const handlerOutsideClick = useCallback(
    (e) => {
      // SVG targets expose className as SVGAnimatedString, which is not a string.
      const targetClassName =
        typeof e.target.className === 'string'
          ? e.target.className
          : e.target.getAttribute?.('class') || ''

      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(e.target) &&
        !targetClassName.includes('bell') &&
        !targetClassName.includes('bell-badge')
      ) {
        hideModal()
      }
    },
    [wrapperRef, hideModal]
  )

  useEffect(() => {
    setOnClickCallback(togglePopup)
    if (setBadgeCount) setBadgeCount()

    window.addEventListener('mousedown', handlerOutsideClick)

    return () => window.removeEventListener('mousedown', handlerOutsideClick)
  }, [])

  return (
    <>
      {showModal && (
        <NavigationPopup ref={wrapperRef} className={className} width={width} id="navigation-popup">
          <div className="content" onClick={togglePopup}>
            {content}
          </div>
        </NavigationPopup>
      )}
    </>
  )
}

export default NavigationItem
